import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center bg-brand-navy text-white/70">Loading...</div>;
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}
